import React from 'react';
import { motion } from 'framer-motion';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { Lock, Zap } from 'lucide-react';
export function PricingSection() {
  return <Section id="pricing" className="relative pb-32" data-id="element-189">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-brand-purple/20 via-brand-dark to-brand-dark -z-10" data-id="element-190" />

      <div className="max-w-4xl mx-auto text-center" data-id="element-191">
        <h2 className="text-4xl md:text-5xl font-bold mb-6" data-id="element-192">
          Obtén Acceso Inmediato
        </h2>
        <p className="text-xl text-brand-gray mb-12 max-w-2xl mx-auto" data-id="element-193">
          No pagues miles de dólares en consultorías de marca personal. Adquiere
          el sistema completo de creación de activos digitales por un pago
          único.
        </p>

        <motion.div className="glass-card p-1 rounded-3xl max-w-md mx-auto relative group" id="pricing-card" initial={{
        opacity: 0,
        y: 40
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} data-id="element-194">
          {/* Animated border gradient */}
          <div className="absolute inset-0 bg-gradient-to-r from-brand-cyan via-brand-purple to-brand-cyan rounded-3xl opacity-50 group-hover:opacity-100 transition-opacity duration-500 blur-sm" data-id="element-195" />

          <div className="bg-brand-darker rounded-[22px] p-8 md:p-10 relative z-10 flex flex-col items-center" data-id="element-196">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-brand-purple/20 text-brand-purpleLight text-sm font-bold uppercase tracking-wider mb-8 border border-brand-purple/30" data-id="element-197">
              <Zap size={16} data-id="element-198" /> Precio de Lanzamiento
            </div>

            <div className="flex items-center justify-center gap-4 mb-2" data-id="element-199">
              <span className="text-3xl text-brand-gray line-through decoration-red-500/50 decoration-2" data-id="element-200">
                $197
              </span>
              <div className="flex items-start" data-id="element-201">
                <span className="text-3xl font-bold text-white mt-2" data-id="element-202">$</span>
                <span className="text-7xl font-black text-transparent bg-clip-text bg-gradient-to-r from-white to-brand-gray" data-id="element-203">
                  27
                </span>
                <span className="text-xl font-bold text-brand-gray mt-auto mb-2 ml-1" data-id="element-204">
                  USD
                </span>
              </div>
            </div>

            <p className="text-brand-cyan font-medium mb-10" data-id="element-205">
              Pago único. Acceso de por vida.
            </p>

            <Button href="https://www.mdbhorizonte.com/cart/52064149012772:1" className="w-full py-5 text-lg mb-6" data-id="element-206">
              ¡QUIERO EMPEZAR MI MARCA GHOST AHORA!
            </Button>

            <div className="flex items-center justify-center gap-2 text-sm text-brand-gray" data-id="element-207">
              <Lock size={16} className="text-green-400" data-id="element-208" />
              <span data-id="element-209">
                Acceso instantáneo tras el pago. Pago seguro y cifrado.
              </span>
            </div>
          </div>
        </motion.div>
      </div>
    </Section>;
}